"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importDefault(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tags_ga_1 = require("../../utils/tags-ga");
var styles_1 = require("./styles");
var InputField = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, hasError = _a.hasError, isTouched = _a.isTouched, inputValid = _a.inputValid, type = _a.type, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, label = _a.label, errorMsg = _a.errorMsg, inputProps = _a.inputProps, required = _a.required, btnAdd = _a.btnAdd, onClickBtnAdd = _a.onClickBtnAdd, width = _a.width, margin = _a.margin, gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, gaEventType = _a.gaEventType, hideErrorIcon = _a.hideErrorIcon, manterEstilo = _a.manterEstilo;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var error = isTouched && hasError;
    var errorClassName = manterEstilo ? "error ".concat(className) : 'error';
    var inputError = hasError ? errorClassName : className;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.InputFieldSectionStyled, { width: width, margin: margin, className: inputValid ? 'valid' : inputError },
            react_1.default.createElement(styles_1.InputFieldInputStyled, __assign({ id: id, "aria-label": label, name: name, type: type, value: value, onChange: onChange, disabled: disabled, error: error, required: required }, inputProps, { className: btnAdd && 'btnAdd' })),
            react_1.default.createElement(styles_1.InputFieldLabelStyled, { type: type }, label),
            btnAdd ? (react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
                react_1.default.createElement(styles_1.InputFieldButtonClearStyled, { type: "button", id: 'botao-adicionar', onClick: onClickBtnAdd },
                    react_1.default.createElement(paragraphy_styles_1.PStyled, { p14: true, color: theme.p001 }, "Adicionar")))) : null,
            error && !hideErrorIcon && type !== 'date' ? (react_1.default.createElement("div", { className: "icoError" },
                react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.AlertTriangle, size: 'md' }))) : null),
        error && errorMsg ? (react_1.default.createElement(paragraphy_styles_1.PStyled, { small: true, bold: true, color: theme.error, style: { marginTop: '8px', marginLeft: '16px', marginBottom: "".concat(error ? '16px' : '0') } }, errorMsg)) : null));
};
exports.InputField = InputField;
